export default "__VITE_ASSET__DQGG9K3s__"